import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api'
import { ArticulosEcommerce, ArticulosGeneral, EcommerceGenericoService, ImagesInterface, PromocionesEccomerce } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { MarianomGeneral } from '../../components/marianom-general.service';


@Component({
  selector: 'app-mmaxhome-landpage',
  templateUrl: './mmaxhome-landpage.component.html',
  styleUrls: ['./mmaxhome-landpage.component.scss']
})
export class MmaxhomeLandpageComponent implements OnInit {
  @Input() ofertasDisplay: string = 'none';
  @Input() promosDisplay: string = 'none';
  @Input() marcasDisplay: string = 'none';

  sucursal: ArticulosEcommerce[] = [];
  hayMarcas: boolean = false;
  verTutoriales: boolean = false;
  isSearching: boolean = false;
  loading: boolean = true;

  constructor(private genServ: EcommerceGenericoService, private modalserv: ModalService) {
    this.ofertasDisplay = this.ofertasDisplay || 'none';
    this.promosDisplay = this.promosDisplay || 'none';
    this.marcasDisplay = this.marcasDisplay || 'none';
  }

  ngOnInit(): void {
    this.verTutoriales = this.genServ.verTutoriales;
    this.genServ.getCarrouselSlides();

    // Si ya hay artículos cargados, detenemos el loading inmediatamente
    if (this.genServ.getSucursalActiva()?.articulos?.length > 0) {
      this.loading = false;
      // NO llamar iniciarbusqueda('') acá
    } else {
      this.loading = true;
    }

    this.genServ.getResultadoDeBusquedaProvider().subscribe((data: any) => {
      if (data && data.textodebusqueda && data.textodebusqueda.length > 0) {
        this.isSearching = true;
      } else {
        this.isSearching = false;
      }
    });

    this.genServ.getAvisoArticulosSucursalCargados().subscribe((data: any) => {
      console.log('DEBUG: MmaxhomeLandpage -> Artículos cargados, desactivando loading.');
      this.loading = false;
      // NO llamar iniciarbusqueda('') acá
    });
  }

  closeModal(text: string) {
    this.modalserv.close(text);

  }

  get articulosEnOfertas() {
    const articulosEnOfertas: ArticulosGeneral[] = this.genServ.getOfertas();
    this.hayMarcas = this.genServ.getMarcasDestacadas().length !== 0;
    return articulosEnOfertas;
  }

  get articulosEnPromociones() {
    const articulosEnPromociones: ArticulosGeneral[] = this.genServ.getArticulosDePromociones();
    return articulosEnPromociones;
  }

  get articulosDestacados(): ArticulosGeneral[] {
    const articulos = this.genServ.getSucursalActiva()?.articulos || [];
    return articulos.filter(articulo => Number(articulo.getDestacado()) === 1);
  }
  get categorias() {
    return this.genServ.getCategoriasWeb();
  }

  get ocultarPrecios() {
    return this.genServ.isOcultarPrecio()
  }

  get ocultarCarrouselCategorias() {
    return this.genServ.getOcultarCarrouselCategorias();
  }

}
